import "./singlePostPage.css";
import SinglePost from "../../../components/blog/singlePost/SinglePost";

export default function SinglePostPage() {
  return (
    <div className="single">
      <SinglePost />
    </div>
  );
}
